import React from 'react';
import './loader.scss';

export const LoaderDots: React.FC = () => (
  <div id="dots_loader">
    <span className="dot" />
    <span className="dot" />
    <span className="dot" />
  </div>
);